import EmailTemplatePreview from "./EmailTemplatePreview/index";
export default EmailTemplatePreview;
